const pivotSill = [
  { id: 1, type: "sillStyle", label: "Dark Bronze Aluminum" },
  { id: 2, type: "sillStyle", label: "Clear Anodized Aluminum" },
  { id: 3, type: "sillStyle", label: "Flat-Grain White Oak Wood" },
];

export { pivotSill };
